<h5 class="text-primary">{{ 'title_keyword_rankings_history' | translate }} "{{data.keyword}}"</h5>
<div class="row">
  <div class="chartKeyLabel ms-5"><i [ngStyle]="{ 'color': mainKeywordColor }" class="fa fa-circle"></i> {{ 'keyword_type_main' | translate }}</div>
  <div class="chartKeyLabel ms-5"><i [ngStyle]="{ 'color': haloKeywordColor }" class="fa fa-circle"></i> {{ 'keyword_type_tracking' | translate }}</div>
</div>
<div class="d-flex p-2 outer-chart-container">
  <canvas baseChart [data]="chartData" [labels]="lineChartLabels" [options]="lineChartOptions"
    [legend]="false" [type]="'line'"></canvas>
</div>
